<template>
   <v-layout row>
     <Loading :value="loading" ></Loading>
    <!--Listes des Chantiers-->
    <v-flex md12>

          <v-layout row>
            <v-card style="width:100%">
              <v-card-text fluid grid-list-md>
                <h4>LISTE DES PROJETS</h4>
                <v-divider class="mb-2" ></v-divider>
                
                 

                  <v-layout row >
                    <v-flex sm12>
                        <data-tables :data="listeProjets" :resizable="false" >
                            <el-table-column prop="created" label="Date" > </el-table-column>
                            <el-table-column prop="libelle" label="Libelle" ></el-table-column>
                            <el-table-column prop="chef" label="Chef Projet" ></el-table-column>
                            <el-table-column prop="dateD" label="Date Début" > </el-table-column> 
                            <el-table-column prop="dateF" label="Date Fin" > </el-table-column> 
                            <el-table-column prop="caisse" label="Caisse" ></el-table-column>
                            <el-table-column prop="estimation" label="Coût estimé" >
                              <template slot-scope="scope">
                                <el-tag  type="info">  {{scope.row.estimation}}</el-tag>
                              </template>
                            </el-table-column>

                            <el-table-column prop="mntDepense" label="Coût des dépenses" >
                              <template slot-scope="scope">
                                <el-tag  type="success">  {{scope.row.mntDepense}}</el-tag>
                              </template>
                            </el-table-column>

                            <el-table-column prop="evolution" label="Evolution" width="140" >
                              <template slot-scope="scope">
                                  <v-progress-circular :size="90" :width="15" :rotate="360" :value="scope.row.evolution" color="primary">
                                      {{scope.row.evolution}} %
                                  </v-progress-circular>
                              </template>
                            </el-table-column>

                            
                            <!-- <el-table-column v-if="user.type == 1" prop="mntFacture" label="MontantTTC (Fcfa)" > </el-table-column> -->
                            <el-table-column label="Action" align="center" fixed="right"  >
                                <template slot-scope="scope">
                                  <v-tooltip top>
                                    <v-btn slot="activator" @click="modalDetail(scope.row)" fab dark small color="blue">
                                      <v-icon dark>list</v-icon>
                                        </v-btn>
                                          Détails...
                                  </v-tooltip>
                                </template>
                              </el-table-column>
                          </data-tables>
                    </v-flex>
                  </v-layout>
                
              </v-card-text>
            </v-card>
          </v-layout>

    </v-flex>
     <!-- DASHBOARD CHANTIER-->
        <DashboardProjet :detailProjet = detailProjet   :show = showDetailProjet  @close="showDetailProjet  = false"> </DashboardProjet >
      <!-- DASHBOARD CHANTIER -->
  
   </v-layout>

 



</template>

<script>


var echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pictorialBar')
require('echarts/lib/chart/funnel')
require('echarts/lib/chart/sankey')
require('echarts/lib/chart/scatter')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
import html2canvas from 'html2canvas';


import Loading from '@/components/Loading';

import DashboardProjet from '@/components/boardProjet/dashboardProjet';


export default {
  components: {Loading,DashboardProjet},
    name: 'ListeProjet',
    props: {
       listeProjets: {
                 type: Array
             },
    },

    data () {

        return {
              //data general
                loading: false,
                detailProjet: {},
                showDetailProjet: false
                       
        }
    },
    computed: {
    },
    methods: {
       modalDetail(item)
       {
         console.log("item ", item)
          this.detailProjet = item;
          this.showDetailProjet = true;
       },
    },
    mounted () {
      

    },


};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/boardProjet/liste_projet.vue